import { createFileRoute } from "@tanstack/react-router";
import { requerirEdicionDeSolicitud } from "@/features/solicitudes/utils/guard-edicion";
import { cecosQueryOptions, cuentasQueryOptions } from "@/features/catalogos/hooks/use-catalogos";
import { ProrrateoSinCfdiPage } from "@/features/prorrateo/components/ProrrateoSinCfdiPage";
import { prorrateoQueryOptions } from "@/features/prorrateo/hooks/use-prorrateo";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/prorrateo-sin-cfdi` · P44 FB60 Contrapago.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/prorrateo-sin-cfdi")({
  beforeLoad: requerirEdicionDeSolicitud,
  loader: ({ context: { queryClient }, params: { id } }) =>
    Promise.all([
      queryClient.ensureQueryData(prorrateoQueryOptions(id)),
      queryClient.ensureQueryData(solicitudQueryOptions(id)),
      queryClient.ensureQueryData(cecosQueryOptions),
      queryClient.ensureQueryData(cuentasQueryOptions),
    ]),
  component: ProrrateoSinCfdiPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
